<template>
    <BlockerAbstract>

        <template #teaser>
            <!-- TODO: add fancy looking apng -->
        </template>

        <template #message>
            Please select a subscription plan to continue.
        </template>

        <template #actions>
            <v-btn
                variant="elevated" 
                color="color1" 
                elevation="1" 
                @click="handleSelect">
                Select Plan
            </v-btn>
        </template> 

    </BlockerAbstract>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import BlockerAbstract from '@/components/common/blocker/BlockerAbstract.vue'

export default {
    name: 'BlockerSubscription',
    components: {
        BlockerAbstract
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleSelect()
        {
            this.openRoute({ route: ROUTES.ACCOUNT.SUBSCRIPTION })
        }
    }
}
</script>